import DOMPurify from 'dompurify';
import { mediaUrl } from '../services/api';

export function plainText(value) {
  return DOMPurify.sanitize(String(value || ''), { ALLOWED_TAGS: [], ALLOWED_ATTR: [], RETURN_DOM_FRAGMENT: true }).textContent || '';
}

export default function RichContent({ html, className = '' }) {
  if (!html) return null;
  const fragment = DOMPurify.sanitize(String(html), { RETURN_DOM_FRAGMENT: true });
  fragment.querySelectorAll('img[src]').forEach((img) => img.setAttribute('src', mediaUrl(img.getAttribute('src'))));
  const container = document.createElement('div');
  container.appendChild(fragment);
  return <div className={`rich-content ${className}`} dangerouslySetInnerHTML={{ __html: container.innerHTML }} />;
}
